import { Button } from "antd";
import React, { useEffect, useState } from "react";
import isEmpty from "../../../core/helpers/isEmpty";
import usePermissions from "../../../core/hooks/usePermissions";
import localize from "../../../core/utils/translation-files";
import { notifications } from "../notifications";
import { JobApi } from "../../../core/api/jobApi";
import RecalculationTriggerDropdown from "./recalculationTriggerDropdown";
const RecalculationTriggerForm = ({ onChangeGroupOptions, groupOptionValues, onApply, customPlaceHolder, haveDefaultCompanyHandler, haveDefaultSiteHandler, allowClearCompany, allowClearGroup = false, allowClearSite, showDropDown = false, allowNAItem = false, }) => {
    const [isTriggerLoading, setIsTriggerLoading] = useState(false);
    const [filterValues, setFilterValues] = useState({
        groupId: null,
        companyId: null,
        siteId: null,
        categoryId: null,
        subcategoryId: null,
        trackedItemId: null,
    });
    const { isSingleSiteAdmin } = usePermissions();
    useEffect(() => {
        if (!isEmpty(groupOptionValues === null || groupOptionValues === void 0 ? void 0 : groupOptionValues.groupId)) {
            setFilterValues(groupOptionValues);
        }
    }, [groupOptionValues]);
    const handelApplyFilter = () => {
        var _a, _b, _c;
        onApply(filterValues);
        onChangeGroupOptions(filterValues);
        setIsTriggerLoading(true);
        JobApi.triggerRecalculation({
            entityId: (_b = (_a = filterValues === null || filterValues === void 0 ? void 0 : filterValues.siteId) !== null && _a !== void 0 ? _a : filterValues === null || filterValues === void 0 ? void 0 : filterValues.companyId) !== null && _b !== void 0 ? _b : filterValues === null || filterValues === void 0 ? void 0 : filterValues.groupId,
            trackedItemOptions: (_c = filterValues === null || filterValues === void 0 ? void 0 : filterValues.trackedItemOptions) !== null && _c !== void 0 ? _c : [],
        })
            .then((res) => {
            if (res.ok) {
                notifications.success(localize(["Recalculation", "triggered", "successfully"]));
            }
        })
            .catch((error) => {
            throw error;
        })
            .finally(() => {
            setIsTriggerLoading(false);
        });
    };
    return (React.createElement(React.Fragment, null, (!isSingleSiteAdmin || showDropDown) && (React.createElement(React.Fragment, null,
        React.createElement(RecalculationTriggerDropdown, { onChangeGroupOptions: setFilterValues, groupOptionValues: filterValues, customPlaceHolder: customPlaceHolder, haveDefaultSiteHandler: haveDefaultSiteHandler, haveDefaultCompanyHandler: haveDefaultCompanyHandler, allowClearCompany: allowClearCompany, allowClearSite: allowClearSite, allowClearGroup: allowClearGroup, allowNAItem: allowNAItem }),
        React.createElement("div", { className: "col-12" },
            React.createElement(Button, { disabled: haveDefaultSiteHandler, loading: isTriggerLoading, htmlType: "button", type: "primary", style: { width: "100%" }, onClick: handelApplyFilter, id: "apply-filter-btn" }, localize(["Button.trigger"])))))));
};
export default RecalculationTriggerForm;
